// src/pages/ResponsePage.js
import React from 'react';
import { useParams } from 'react-router-dom';
import ResponseManager from '../components/ui/ResponseManager';

function ResponsesPage() {
	const { surveyId } = useParams();

	return (
		<ResponseManager surveyId={surveyId} />
	);
}

export default ResponsesPage;